// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1q3hL","selects":"Documents_selects__3Tc7P"};